<template>
  <div class="submit-wrapper">
    <div class="submit-block">
      <span v-if="countErrors" class="md-error"><span class="underline">{{countErrors}}</span> {{ 'section' | pluralize(countErrors)}} {{ 'need' | reverse_pluralize(countErrors)}} to be completed.</span>
    </div>
  </div>
</template>

<script>
import FbElementMixin from "./FbElementMixin";

export default {
  name: "FbSubmitError",
  props: ["element", "mode", "validate", "showSubmit"],
  mixins: [FbElementMixin],
  computed: {
    valid() {
      return true;
    },
    countErrors() {
      return this.validationFails.filter((validation)=>{
        return !validation;
      }).length;
    }
  },
  created() {
    this.$emit("validation", this.valid);

  }
};
</script>

<style lang="scss" scoped>
.md-button.md-theme-default.md-accent.md-accent.icon-right[disabled] .md-icon {
  color:rgba(0, 0, 0, 0.26);
}
.underliune {
  text-decoration: underline;
}
.submit-wrapper {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  .submit-block {
    flex: 1;
    h5 {
      font-size: 18px;
      @media all and (min-width: $breakpoint-medium) {
        font-size: 20px;
      }
    }
  }
}
.fb-submit-btn {
  margin-top: 32px;
}
.md-button {
  font-size: 16px;
  height: 36px;
  @media all and (min-width: $breakpoint-medium) {
    font-size: 20px;
    height: 40px;
  }
}
</style>
